// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchReseaux ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/reseaux`).then(({ data }) => {
      commit("addReseaux", data);
    });
  },
  async fetchReseauxPage({commit}, params = {}) {
    const { pageNumber = 0, pageSize = 10, sort = '', codeCouleur = '', code = '', libelle = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      pageNumber,
      pageSize,
      sort, 
      ...(code && { code }),
      ...(codeCouleur && { codeCouleur }),
      ...(libelle && { libelle }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/reseaux/page?${queryParams}`);
    commit("addReseauxPage", data)
    return data;
  },
  createReseau ({ commit }, reseaux) {
    return post('/canal/reseaux', reseaux)
      .then(({ data }) => {
        commit('addReseaux', data)
      })
  },
  updateReseau ({ commit }, reseaux) {
    return put(`/canal/reseaux/${reseaux.id}`, reseaux)
      .then(({ data }) => {
        commit('replaceReseaux', data)
      })
  },
  createOrUpdateReseau ({ dispatch }, reseaux) {
    if (reseaux.id !== undefined) {
      return dispatch('updateReseau', reseaux)
    } else {
      return dispatch('createReseau', reseaux)
    }
  },
  selectReseau ({ commit }, reseaux) {
    commit('setReseau', reseaux)
  },
  deleteReseau ({ commit}, reseaux) {
    return remove(`/canal/reseaux/${reseaux.id}`)
      .then(({ data }) => {})
  },
}
